import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { getUUID } from '../utils';
import * as t from 'ts-schema';
import { ValidationError } from '../errors';
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
var _payloadSchema = /*#__PURE__*/_classPrivateFieldLooseKey("payloadSchema");
export class MessageBuilder {
  constructor({
    type,
    payload,
    payloadSchema,
    replyType
  }) {
    Object.defineProperty(this, _instance, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _payloadSchema, {
      writable: true,
      value: void 0
    });
    this.setTopic = topic => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].topic = topic;
      return this;
    };
    this.setSender = clientId => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].sender = clientId;
      return this;
    };
    this.setDispatchedAt = () => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].dispatchedAt = Date.now();
      return this;
    };
    this.setCrossPortal = isCrossPortalTopic => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].crossPortal = isCrossPortalTopic;
      return this;
    };
    this.setSenderPortalId = portalId => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].senderPortalId = portalId;
      return this;
    };
    this.setSenderBrokerId = brokerId => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].senderBrokerId = brokerId;
      return this;
    };
    this.setAllowCrossTab = allowCrossTab => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].allowCrossTab = allowCrossTab;
      return this;
    };
    this.build = () => {
      const requiredFields = ['type', 'id', 'sender', 'topic', 'dispatchedAt', 'crossPortal', 'senderPortalId', 'allowCrossTab', 'senderBrokerId'];
      const missingField = requiredFields.find(field => _classPrivateFieldLooseBase(this, _instance)[_instance][field] === undefined);
      if (missingField) {
        throw new Error(`Failed to build message, field "${missingField}" was not prepared.`);
      }
      return _classPrivateFieldLooseBase(this, _instance)[_instance];
    };
    this.getType = () => _classPrivateFieldLooseBase(this, _instance)[_instance].type;
    this.isPayloadValid = () => {
      if (!_classPrivateFieldLooseBase(this, _payloadSchema)[_payloadSchema]) {
        return !_classPrivateFieldLooseBase(this, _instance)[_instance].payload;
      }
      return t.validate(_classPrivateFieldLooseBase(this, _payloadSchema)[_payloadSchema], _classPrivateFieldLooseBase(this, _instance)[_instance].payload);
    };
    this.getReplyType = () => _classPrivateFieldLooseBase(this, _instance)[_instance].replyType;
    this.getId = () => _classPrivateFieldLooseBase(this, _instance)[_instance].id;
    this.setReplyTo = messageId => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].replyTo = messageId;
      return this;
    };
    this.validate = onValidationError => {
      if (this.isPayloadValid()) {
        return;
      }
      const validationError = new ValidationError(ValidationError.Reason.INVALID_PAYLOAD);
      onValidationError(validationError);
    };
    _classPrivateFieldLooseBase(this, _instance)[_instance].id = getUUID();
    _classPrivateFieldLooseBase(this, _instance)[_instance].type = type;
    _classPrivateFieldLooseBase(this, _instance)[_instance].payload = payload;
    _classPrivateFieldLooseBase(this, _instance)[_instance].crossPortal = false;
    _classPrivateFieldLooseBase(this, _instance)[_instance].replyType = replyType;
    _classPrivateFieldLooseBase(this, _payloadSchema)[_payloadSchema] = payloadSchema;
  }
}